import './hubspot-button.scss';
import './hubspot-button.twig';

import eventTypes from '../../00-protons/events/event-types';

const hubspotButtonShowClass = 'hubspot-button--show';

const hubspotButtonSelector = '.hubspot-button';

/**
 * @param {Document | HTMLElement} context
 */
export function enable(context) {
  let initialized = false;

  const initialize = () => {
    // TODO: what happens now with user centrics?
    if (!initialized && window.hbspt /*&& hasAccepted('essential')*/) {
      context
        .querySelectorAll(hubspotButtonSelector)
        .forEach((hubspotButton) => {
          const { portalId, formId, formTargetId } = hubspotButton.dataset;
          hubspotButton.addEventListener('click', () => {
            const iframe = document.querySelector(`#${formTargetId} iframe`);
            if(iframe) {
              iframe.parentNode.removeChild(iframe);
            }
            window.hbspt.forms.create({
              portalId: portalId,
              formId: formId,
              target: `#${formTargetId}`,
            });
          })
          hubspotButton.classList.add(hubspotButtonShowClass);
        });
      initialized = true;
    }
  };

  initialize();
  // window.addEventListener(eventTypes.cookieCompliancePost, () => {
  //   initialize();
  // });
}

export default enable;
